import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, GeoJSON, Marker, useMapEvents, Tooltip} from 'react-leaflet';
import { saveAs } from 'file-saver';
import { predictions } from '../data/prediction';
import { indegoIcon } from '../icon/indegoIcon';
import * as turf from '@turf/turf';
import area from '@turf/area';
import { IndegoStations } from './IndegoStations';
import SecnarioAPolygon from './SecnarioAPolygon';
import RidershipPolygon from './RidershipPolygon';
import PopulationPolygon from './PopulationPolygon';
import { indego_stations } from '../data/indego_stations';
// import { isochrones } from '../data/isochrones';
import { isochrones } from '../data/isochrones5min';
import MapLabels from './MapLabels';
import ResultDashboard from './ResultDashboard';
import InstructionPopup from './InstructionPopup';


function ScenarioEvaluator() {
   
  const [uniqueIds, setUniqueIds] = useState(new Set());
  const [newStationPredictions, setNewStationPredictions] = useState({
    type: "FeatureCollection",
    features: []
  });
  const [markers, setMarkers] = useState([]);
  const [savedMarkers, setSavedMarkers] = useState([]);
  const [predValues, setPredValues] = useState([]);
  const [showScenarioA, setShowScenarioA] = useState(false);
  const [showRidership, setShowRidership] = useState(false);
  const [showPopulation, setShowPopulation] = useState(false);
  const [intersectedPredictionIds, setIntersectedPredictionIds] = useState([]);
  const [filteredIsochrones, setFilteredIsochrones] = useState({
    type: "FeatureCollection",
    features: []
  });
  const [isoPredictions, setIsoPredictions] = useState({
    type: "FeatureCollection",
    features: [],
  });
  const [accessibilitySum, setAccessibilitySum] = useState(0);
  const [totalRidershipCurrent, setTotalRidershipCurrent] = useState([17941]);
  const [currentStationIsochronePrediction, setCurrentStationIsochronePrediction] = useState({
    type: 'FeatureCollection',
    features: [],
  });
  const [currentStationsAccessbilitySum, setCurrentStationsAccessbilitySum] = useState([289531]);
  const [currentEquitySum, setCurrentEquitySum] = useState({
    "pct_white": 0,
    "pct_Black": 0,
    "pct_Asian": 0,
    "pct_HispLat": 0,
    "pct_other_race": 0,
  });
  const [currentNullCounts, setCurrentNullCounts] = useState({
    "pct_white": 0,
    "pct_Black": 0,
    "pct_Asian": 0,
    "pct_HispLat": 0,
    "pct_other_race": 0,
  });
  const [currentEquityMean, setCurrentEquityMean] = useState({
    "pct_white": 42.12,
    "pct_Black": 37.25,
    "pct_Asian": 8.33,
    "pct_HispLat": 8.51,
    "pct_other_race": 7.01,
  });
  const [scenarioEquitySum, setScenarioEquitySum] = useState({
    "pct_white": 0,
    "pct_Black": 0,
    "pct_Asian": 0,
    "pct_HispLat": 0,
    "pct_other_race": 0,
  });
  const [scenarioNullCounts, setScenarioNullCounts] = useState({
    "pct_white": 0,
    "pct_Black": 0,
    "pct_Asian": 0,
    "pct_HispLat": 0,
    "pct_other_race": 0,
  });
  const [scenarioEquityMean, setScenarioEquityMean] = useState({});
  const [equityData, setEquityData] = useState([]);



  function createGeoJSON(features) {
    return {
      type: 'FeatureCollection',
      features: features,
    };
  }

  //Evaluation results ridership
  const totalPredValue = predValues.reduce((acc, curr) => acc + Number(curr), 0);

   //current stations geojson
  const currentStationsGrid = createGeoJSON(
    predictions.features.filter((feature) => {
      return indego_stations.features.some((station) => {
        return turf.booleanPointInPolygon(station.geometry, feature.geometry);
      });
    })
  );  

  //current stations Grid unique id
  const currentStationsGridUniqueId = currentStationsGrid.features.map((feature) => {
    return feature.properties.unique_id;
  });

    //current stations geojson iso_id list
  const isoIdList = currentStationsGrid.features.map((feature) => {
    return feature.properties.iso_id;
  });
   
  //current stations geojson isochrones
  const currentStationIsochrone = {
    type: 'FeatureCollection',
    features: isochrones.features.filter((feature) => {
      return isoIdList.includes(feature.properties.id);
    }),
  };

  //current stations geojson iso_id list
  const currentStationIsochronePredictionUniqueId = currentStationIsochronePrediction.features.map((feature) => {
    return feature.properties.unique_id;
  });

 
  // calling function to update isoPredictions
  useEffect(() => {
    updateIsoPredictions(currentStationIsochronePrediction);
  }, [filteredIsochrones, currentStationIsochronePrediction]);
  

  //  calling function to update accessibilitySum
  useEffect(() => {
    const uniqueFeatures = new Map();
    let tempAccessibilitySum = 0;
 
    isoPredictions.features.forEach((feature) => {
      const unique_id = feature.properties.unique_id;
  
      if (!uniqueFeatures.has(unique_id)) {
        uniqueFeatures.set(unique_id, feature);
      }
    });
  
    uniqueFeatures.forEach((feature) => {
      tempAccessibilitySum += feature.properties.pop_per_cell;
    });
  
  // scenarioEquity
  let addedEquitySum = {
    "pct_white": 0,
    "pct_Black": 0,
    "pct_Asian": 0,
    "pct_HispLat": 0,
    "pct_other_race": 0,
  }
  
    uniqueFeatures.forEach((feature) => {
    addedEquitySum.pct_white += feature.properties.pct_white;
    addedEquitySum.pct_Black += feature.properties.pct_Black;
    addedEquitySum.pct_Asian += feature.properties.pct_Asian;
    addedEquitySum.pct_HispLat += feature.properties.pct_HispLat;
    addedEquitySum.pct_other_race += feature.properties.pct_other_race;
  });

  let addedNullCounts = {
    "pct_white": uniqueFeatures.size,
    "pct_Black": uniqueFeatures.size,
    "pct_Asian": uniqueFeatures.size,
    "pct_HispLat": uniqueFeatures.size,
    "pct_other_race": uniqueFeatures.size,
  }
  
  let ScenarioNullCounts = {}

  for (let key in addedNullCounts) {
    ScenarioNullCounts[key] = addedNullCounts[key] + currentNullCounts[key];
  }

  let ScenarioEquitySum = {}

  for (let key in addedEquitySum) {
    ScenarioEquitySum[key] = addedEquitySum[key] + currentEquitySum[key];
  }

    // Update state with new values
  setScenarioEquitySum(ScenarioEquitySum);
  setScenarioNullCounts(addedNullCounts);

  // Calculate the mean for each property and round to two decimal places
  let scenarioEquityMean = {};
  
  for (const prop in ScenarioEquitySum) {
    scenarioEquityMean[prop] = (
      ScenarioEquitySum[prop] / ScenarioNullCounts[prop]
    ).toFixed(2);
  }      // Update propertyMeans state
  setScenarioEquityMean(scenarioEquityMean);
  setAccessibilitySum(tempAccessibilitySum);

  }, [isoPredictions]);

 

  useEffect(() => {
    // Wrap your code in a function and call it inside useEffect or any other callback function
    const calculateCurrentStationIsochronePrediction = () => {

      const newCurrentStationIsochronePrediction = {
        type: 'FeatureCollection',
        features: predictions.features
          .filter((prediction) => {
            return currentStationIsochrone.features.some((currentStationIsochrone) => {
              const intersection = turf.intersect(currentStationIsochrone.geometry, prediction.geometry);
              if (!intersection) return false;
      
              const intersectionArea = area(intersection);
              const predictionArea = area(prediction.geometry);
              const intersectionPercentage = (intersectionArea / predictionArea) * 100;
      
              return intersectionPercentage > 30;
            });
          })
          .filter((filteredPrediction, index, self) => {
            return self.findIndex((feature) => feature.properties.unique_id === filteredPrediction.properties.unique_id) === index;
          }),
      };

      setCurrentStationIsochronePrediction(newCurrentStationIsochronePrediction);
    };

    

    calculateCurrentStationIsochronePrediction();
  }, []); 




  useEffect(() => {
    // Calculate sums and non-null counts for each property

      let currentEquitySum = {
        "pct_white": 0,
        "pct_Black": 0,
        "pct_Asian": 0,
        "pct_HispLat": 0,
        "pct_other_race": 0,
      };
    
      let currentNullCounts = {
        "pct_white": 0,
        "pct_Black": 0,
        "pct_Asian": 0,
        "pct_HispLat": 0,
        "pct_other_race": 0,
      };

      currentStationIsochronePrediction.features.forEach(function (station) {
        for (const prop in currentEquitySum) {
          if (station.properties[prop] !== null) {
            currentEquitySum[prop] += station.properties[prop];
            currentNullCounts[prop]++;
          }
        }
      });

      // Update state with new values
      setCurrentEquitySum(currentEquitySum);
      setCurrentNullCounts(currentNullCounts);

      // Calculate the mean for each property and round to two decimal places
      let currentEquityMean = {};
      for (const prop in currentEquitySum) {
        currentEquityMean[prop] = (
          currentEquitySum[prop] / currentNullCounts[prop]
        ).toFixed(2);
      }      // Update propertyMeans state
      setCurrentEquityMean(currentEquityMean);

  }, [currentStationIsochronePrediction]);


  useEffect(() => {
    const calculateEquityData = () => {
      const races = [
        { key: 'pct_white', label: 'White' },
        { key: 'pct_Black', label: 'Black' },
        { key: 'pct_Asian', label: 'Asian' },
        { key: 'pct_HispLat', label: 'Hisp/Lat' },
        { key: 'pct_other_race', label: 'Others' },
      ];

      const newEquityData = races.map(({ key, label }) => {
        const diff = (scenarioEquityMean[key] - currentEquityMean[key]).toFixed(2);
        const cssClass = diff > 0 ? 'red' : 'blue';
        const text = diff > 0 ? '▲' : '▼';

        return { label, diff, cssClass, text, percentage: scenarioEquityMean[key] };
      });

      setEquityData(newEquityData);
    };

    calculateEquityData();
  }, [scenarioEquityMean, currentEquityMean]);


function updateIsoPredictions(targetIsoId) {
  let filteredPredictions = predictions.features;

  if (targetIsoId) {
    filteredPredictions = filteredPredictions.filter((prediction) => {
      return prediction.properties.id !== targetIsoId;
    });
  }

  const newIsoPredictions = filteredPredictions.filter((prediction) => {
    if (currentStationIsochronePredictionUniqueId.includes(prediction.properties.unique_id)) {
      return false;
    }

    return filteredIsochrones.features.some((filteredIsochrone) => {
      const intersection = turf.intersect(filteredIsochrone.geometry, prediction.geometry);
      if (!intersection) return false;

      const intersectionArea = area(intersection);
      const predictionArea = area(prediction.geometry);
      const intersectionPercentage = (intersectionArea / predictionArea) * 100;

      return intersectionPercentage > 50;
    });
  });

  const filteredNewIsoPredictions = newIsoPredictions.filter((prediction) => {
    if (currentStationIsochronePredictionUniqueId.includes(prediction.properties.unique_id)) {
      return false;
    }
    return true;
  });

  setIsoPredictions({
    type: "FeatureCollection",
    features: filteredNewIsoPredictions,
  });
}


//Start:EventHnadler--------------------------------------------------------------------------------------------------------------------//
  

  // 1. Map click event handler
  function handleMapClick(event) {
    const { lat, lng } = event.latlng;
    setMarkers((prevMarkers) => [...prevMarkers, { lat, lng }]);
  
    const intersectedPredictions = predictions.features.filter((feature) => {
      const point = turf.point([lng, lat]);
      return turf.booleanPointInPolygon(point, feature.geometry);
    });
  
    const tempNewUniqueIds = new Set();
  
    const tempStationPrediction = intersectedPredictions.filter((feature) => {
      const id = feature.properties.unique_id;
      
      // Check if the unique_id is in currentStationsGridUniqueId list and not in uniqueIds set
      if (!currentStationsGridUniqueId.includes(id) && !uniqueIds.has(id)) {
        tempNewUniqueIds.add(id);
        return true;
      }
      return false;
    });
  
    setUniqueIds((prevUniqueIds) => new Set([...prevUniqueIds, ...tempNewUniqueIds]));
  
    setNewStationPredictions((prevNewStationPrediction) => ({
      ...prevNewStationPrediction,
      featrue: [...prevNewStationPrediction.features, ...tempStationPrediction]
    }));
  
    const newPredValues = tempStationPrediction.map((prediction) => Number(prediction.properties["predicted_ridership_week"]).toFixed(0));
    setPredValues((prevPredValues) => [...prevPredValues, ...newPredValues]);

    const newPredictionIds = tempStationPrediction.map((prediction) => prediction.properties["iso_id"]);
    setIntersectedPredictionIds((prevIntersectedPredictionIds) => [...prevIntersectedPredictionIds, ...newPredictionIds]);

    const newFilteredIsochrones = isochrones.features.filter((feature) =>
      newPredictionIds.includes(feature.properties.id)
    );
    setFilteredIsochrones((prevFilteredIsochrones) => ({
      ...prevFilteredIsochrones,
      features: [...prevFilteredIsochrones.features, ...newFilteredIsochrones]
    }));
  }
      
  // 2. reset event handler 
  function resetMarkers() {
    setMarkers([]);
    setPredValues([]);
    setIntersectedPredictionIds([]);
    setFilteredIsochrones({
      type: "FeatureCollection",
      features: []
    })
    setIsoPredictions({
      type: "FeatureCollection",
      features: []
    })
    setScenarioEquitySum({
      "pct_white": 0,
      "pct_Black": 0,
      "pct_Asian": 0,
      "pct_HispLat": 0,
      "pct_other_race": 0,
    });
    setUniqueIds(new Set())
  }

  function MapClickHandler() {
    const map = useMapEvents({
      click(event) {
        handleMapClick(event);
      },
    });
    return null;
  }

  // 3. save currend markers to geojson file
  function handleSaveMarkers() {
    const geojson = {
      type: 'FeatureCollection',
      features: markers.map((marker, index) => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [marker.lng, marker.lat],
        },
        properties: {
          name: `Marker ${index + 1}`,
        },
      })),
    };

    const blob = new Blob([JSON.stringify(geojson)], { type: 'application/json' });
    saveAs(blob, 'stations.geojson');

    setSavedMarkers(markers);
  }

  // 4. remove marker from list
  function handleRemoveMarker(index) {
    const newMarkers = markers.filter((_, i) => i !== index);
    setMarkers(newMarkers);
    setSavedMarkers(newMarkers);
  
    const newPredValues = predValues.filter((_, i) => i !== index);
    setPredValues(newPredValues);
  
    const newIntersectedPredictionIds = intersectedPredictionIds.filter((_, i) => i !== index);
    setIntersectedPredictionIds(newIntersectedPredictionIds);
  
    const targetIsoId = intersectedPredictionIds[index];
    const newFilteredIsochronesFeatures = filteredIsochrones.features.filter(
      (feature) => feature.properties.id !== targetIsoId
    );
    setFilteredIsochrones({
      type: "FeatureCollection",
      features: newFilteredIsochronesFeatures,
    });

    updateIsoPredictions(targetIsoId, currentStationIsochronePrediction);
  }

  // 5. upload geojson file
  function handleGeoJSONUpload(event) {
    resetMarkers();
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const geojson = JSON.parse(event.target.result);
      const newMarkers = geojson.features.map((feature) => ({
        lat: feature.geometry.coordinates[1],
        lng: feature.geometry.coordinates[0],
      }));
      setMarkers(newMarkers);
  
      newMarkers.forEach(({ lat, lng }) => {
        const intersectedPredictions = predictions.features.filter((feature) => {
          const point = turf.point([lng, lat]);
          return turf.booleanPointInPolygon(point, feature.geometry);
        });
  
        const tempNewUniqueIds = new Set();
  
        const tempStationPrediction = intersectedPredictions.filter((feature) => {
          const id = feature.properties.unique_id;
  
          if (!currentStationsGridUniqueId.includes(id) && !uniqueIds.has(id)) {
            tempNewUniqueIds.add(id);
            return true;
          }
          return false;
        });
  
        setUniqueIds((prevUniqueIds) => new Set([...prevUniqueIds, ...tempNewUniqueIds]));
  
        setNewStationPredictions((prevNewStationPrediction) => ({
          ...prevNewStationPrediction,
          features: [...prevNewStationPrediction.features, ...tempStationPrediction],
        }));
  
        const newPredValues = tempStationPrediction.map((prediction) => Number(prediction.properties["predicted_ridership_week"]).toFixed(0));
        setPredValues((prevPredValues) => [...prevPredValues, ...newPredValues]);
  
        const newPredictionIds = tempStationPrediction.map((prediction) => prediction.properties["iso_id"]);
        setIntersectedPredictionIds((prevIntersectedPredictionIds) => [...prevIntersectedPredictionIds, ...newPredictionIds]);
  
        const newFilteredIsochrones = isochrones.features.filter((feature) =>
          newPredictionIds.includes(feature.properties.id)
        );
        setFilteredIsochrones((prevFilteredIsochrones) => ({
          ...prevFilteredIsochrones,
          features: [...prevFilteredIsochrones.features, ...newFilteredIsochrones],
        }));
      });
    };
    reader.readAsText(file);
  }




// Exsiting Indego Stations style
function getFeatureStyle(feature) {
  return {
    color: 'grey',
    fillColor: 'transparent',
    weight: 0.2,
  };
}


//Isochrone grid style
const getFeatureStyle2 = () => {
  return {
    color: "transparent",
    weight: 0.8,
    opacity: 0.7,
    fillColor: "#0078a8",
    fillOpacity: 0.1,
  };
};

//Isochrone grid style
const getFeatureStyle3 = () => {
  return {
    color: "black",
    weight: 0.8,
    opacity: 0.7,
    fillColor: "#0078a8",
    fillOpacity: 0.0,
  };
};



//End:Style--------------------------------------------------------------------------------------------------------------------//

  return (
    
    <div className="planner-container">
      <InstructionPopup />
      <div className="map-container">
        <MapContainer
          className="neighborhoods__map"
          center={[39.9996, -75.1347]}
          zoom={11}
          scrollWheelZoom={true}
          doubleClickZoom={false}
          zoomSnap={0.25}
          zoomControl={false}
        >
          <TileLayer url="https://api.mapbox.com/styles/v1/kmu973/cl8w28f1e002i14qenl8ilhxy/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoia211OTczIiwiYSI6ImNsZ2d6ODE2azBnYnIzcnE2dnFoczV3OTkifQ.g2fwKwhMGD5Kl5ggVZiAdw" />
          
          {showRidership && <RidershipPolygon />} 
          {showPopulation && <PopulationPolygon />} 


          <GeoJSON data={predictions} style={getFeatureStyle} />

          {/* <GeoJSON
            key={currentStationIsochrone.features.length}
            data={currentStationIsochrone}
            style={getFeatureStyle3}
          /> */}


          <GeoJSON
            key={currentStationIsochronePrediction.features.length}
            data={currentStationIsochronePrediction}
            style={getFeatureStyle2}
          />

          <GeoJSON
            key={isoPredictions.features.length}
            data={isoPredictions}
            style={getFeatureStyle2}
          />

          {showScenarioA && <SecnarioAPolygon />} 
    
          {/* <HomeButton position={[39.9996, -75.1347]} zoom={11} /> */}
          {markers.map((marker, index) => (
            <Marker key={index} position={[marker.lat, marker.lng]} icon={indegoIcon}>
              <Tooltip direction="top" offset={[0, -10]}> Station {index + 1} </Tooltip>
            </Marker>
          ))}
          <IndegoStations/>

          <MapClickHandler />

        </MapContainer>
        
      </div>
      
      <div>
        <MapLabels showScenarioA={showScenarioA} setShowScenarioA={setShowScenarioA} 
          showRidership={showRidership} setShowRidership={setShowRidership} 
          showPopulation={showPopulation} setShowPopulation={setShowPopulation} 
        />
      </div>

      <div>
        <ResultDashboard
          markers={markers}
          resetMarkers={resetMarkers}
          handleRemoveMarker={handleRemoveMarker}
          totalRidershipCurrent={totalRidershipCurrent}
          totalPredValue={totalPredValue}
          currentStationsAccessbilitySum={currentStationsAccessbilitySum}
          accessibilitySum={accessibilitySum}
          equityData={equityData}
          handleSaveMarkers={handleSaveMarkers}
          handleGeoJSONUpload={handleGeoJSONUpload}
        />
      </div>     
      
    </div>   

  );
}

export default ScenarioEvaluator;
